<template>
  <DynamicGraph :lottie-json="noCommentLottie" :is-full-height="false" />

  <div class="load-txt">
    暂无评论
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, defineAsyncComponent, toRefs, onMounted } from 'vue';
import { useGlobalState, useStat } from '@cpc/comment-sdk-core-comment';
import { useOsVersionLottie } from '../core/useOsVersionLottie';
import { useBrowserVersion } from '../core/useBrowserVersion';

import noContent from '../assets/lottie/no-content-light.json?url';
import noContentDark from '../assets/lottie/no-content-dark.json?url';

export default defineComponent({
  name: 'NoCommentTip',

  components: {
    DynamicGraph: defineAsyncComponent(() => import('./DynamicGraph.vue')),
  },

  // props: {},

  setup() {
    const { isNightMode } = toRefs(useGlobalState());

    const { getVersionLottieResource } = useOsVersionLottie();
    const { getColorOsVersion } = useBrowserVersion();

    const noCommentLottie = computed(() => {
      return getVersionLottieResource(getColorOsVersion(), isNightMode.value, 'noComment');
      // return isNightMode.value ? noContentDark : noContent;
    });

    onMounted(() => {
      const durationTime = window.__TEMPLATE_COMMEMT_DATA__?.startTime
        ? Date.now() - window.__TEMPLATE_COMMEMT_DATA__.startTime
        : window.performance.now();

      window.generalPerfStat?.({ action: 'firstComment', durationTime });
      window.commentCommonHelps?.performanceStat?.('H5_commentViewsRenderComplete');
    });

    return {
      noCommentLottie,
    };
  },
});
</script>

<style scoped lang="scss">
@import '../assets/css/load-bar.scss';
</style>
